<template>
	<div>
		<router-view />
	</div>

</template>

<script>
    export default {
        name: "roles"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/roles/roles.vue